import login from './login'
import secondFactor from './secondFactor'
import impersonation from './impersonation'
import azureLogin from './azure-login'

export default {
    azureLogin,
    impersonation,
    login,
    secondFactor
}
